import React from 'react'
import { history } from '../store'

class FaultsByMachineList extends React.Component {
  goTo(Serial, e) {
    history.push(`/machines/${Serial}`)
  }

  renderFaultList() {
    const { matrixs, machines } = this.props;

    let faultList = [];

    // Create an array of fault objects with customer name, serial, and fault counts
    matrixs.forEach((matrix) => {
      const faults = {
        customer: "",
        serial: matrix.Serial,
        BROKEN_LOCK: 0,
        GREEN_BLOCK: 0,
        RED_BLOCK: 0,
        PINPAD_BLOCK: 0,
        DOOR_BLOCK: 0,
        PINPAD_ACTIVE: 0,
        TOTAL_FAULTS: 0,
      };

      machines.forEach((machine) => {
        if (machine.Serial === matrix.Serial) {
          faults.customer = machine.Customer?.Fullname || 'None';
        }
      });

      matrix.Locker.forEach((lock) => {
        if (lock.FaultCode !== undefined && lock.Status === "FL") {
          switch (lock.FaultCode) {
            case "BROKEN_LOCK":
              faults.BROKEN_LOCK++;
              faults.TOTAL_FAULTS++;
              break;
            case "GREEN_BLOCK":
              faults.GREEN_BLOCK++;
              faults.TOTAL_FAULTS++;
              break;
            case "RED_BLOCK":
              faults.RED_BLOCK++;
              faults.TOTAL_FAULTS++;
              break;
            case "PINPAD_BLOCK":
              faults.PINPAD_BLOCK++;
              faults.TOTAL_FAULTS++;
              break;
            case "DOOR_BLOCK":
              faults.DOOR_BLOCK++;
              faults.TOTAL_FAULTS++;
              break;
            case "PINPAD_ACTIVE":
              faults.PINPAD_ACTIVE++;
              faults.TOTAL_FAULTS++;
              break;
            default:
              break;
          }
        }
      });

      if (faults.TOTAL_FAULTS > 0) {
        faultList.push(faults);
      }
    });

    // Sort the faultList by customer name in alphabetical order
    faultList.sort((a, b) => a.customer.localeCompare(b.customer));

    const filter = (this.props.filterText || '').trim().toLowerCase();
    const filteredList = filter ? faultList.filter(f => (f.customer || '').toLowerCase().includes(filter) || (f.serial || '').toLowerCase().includes(filter)) : faultList;

    return filteredList.map((fault) => (
      <div key={fault.serial} className="list-group-item fault-card d-flex align-items-start justify-content-between" onClick={(e) => this.goTo(fault.serial, e)}>
        <div style={{ flex: 1 }}>
          <div className="font-weight-bold">{fault.customer || '—'}</div>
          <div className="text-muted small">{fault.serial}</div>
        </div>
        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          <span className="badge fault-total-badge">Total {fault.TOTAL_FAULTS}</span>
          <div className="fault-chips" style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
            <span className="badge badge-light">Pinchos: {fault.BROKEN_LOCK}</span>
            <span className="badge badge-light">Verde: {fault.GREEN_BLOCK}</span>
            <span className="badge badge-light">Rojo: {fault.RED_BLOCK}</span>
            <span className="badge badge-light">Teclado: {fault.PINPAD_BLOCK}</span>
            <span className="badge badge-light">Puerta: {fault.DOOR_BLOCK}</span>
            <span className="badge badge-light">T. encendido: {fault.PINPAD_ACTIVE}</span>
          </div>
        </div>
      </div>
    ));
  }

  render() {
    if (!this.props.matrixs) {
      return null
    }

    return (
      <div className="list-group">
        {this.renderFaultList()}
      </div>
    )
  }
}

export default FaultsByMachineList

